import * as D from 'io-ts/Decoder';

export const ACTimeOptionDecoder = D.union(
    D.literal('Night'),
    D.literal('Morning'),
    D.literal('Afternoon'),
    D.literal('Evening'),
);
